__turbopack_context__.v({
  "card": "cart-recommendations-module-scss-module__O4GVWG__card",
  "close": "cart-recommendations-module-scss-module__O4GVWG__close",
  "cta": "cart-recommendations-module-scss-module__O4GVWG__cta",
  "error": "cart-recommendations-module-scss-module__O4GVWG__error",
  "name": "cart-recommendations-module-scss-module__O4GVWG__name",
  "photo": "cart-recommendations-module-scss-module__O4GVWG__photo",
  "picker": "cart-recommendations-module-scss-module__O4GVWG__picker",
  "picker-body": "cart-recommendations-module-scss-module__O4GVWG__picker-body",
  "picker-cta": "cart-recommendations-module-scss-module__O4GVWG__picker-cta",
  "picker-grid": "cart-recommendations-module-scss-module__O4GVWG__picker-grid",
  "picker-head": "cart-recommendations-module-scss-module__O4GVWG__picker-head",
  "picker-name": "cart-recommendations-module-scss-module__O4GVWG__picker-name",
  "picker-photo": "cart-recommendations-module-scss-module__O4GVWG__picker-photo",
  "picker-title": "cart-recommendations-module-scss-module__O4GVWG__picker-title",
  "price": "cart-recommendations-module-scss-module__O4GVWG__price",
  "root": "cart-recommendations-module-scss-module__O4GVWG__root",
  "row": "cart-recommendations-module-scss-module__O4GVWG__row",
  "title": "cart-recommendations-module-scss-module__O4GVWG__title",
  "variant": "cart-recommendations-module-scss-module__O4GVWG__variant",
  "variants": "cart-recommendations-module-scss-module__O4GVWG__variants",
});
